"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfoContainer = void 0;
exports.mapStateToProps = mapStateToProps;
var _reactRedux = require("react-redux");
var _selectors = require("./selectors");
var _PhoneSmsConfirmationInfo = require("../../../../components/PhoneSmsConfirmationInfo");
function mapStateToProps(state) {
  return {
    phone: (0, _selectors.phoneSelector)(state)
  };
}
const InfoContainer = exports.InfoContainer = (0, _reactRedux.connect)(mapStateToProps)(_PhoneSmsConfirmationInfo.PhoneSmsConfirmationInfo);